/* count-up-number-animation.js */

/** for chrome-behavior: detects if there is scrolling on an <input type="number"> and prevents increasing the number on scroll */

export default function countUpNumber(targer, time = 200, start = 0) {
    return {
        current: 0,
        target: targer,
        time: time,
        start: start,
        updatecounter: function () {
            start = this.start;
            const increment = (this.target - start) / this.time;
            const handle = setInterval(() => {
                if (this.current < this.target) this.current += increment;
                else {
                    clearInterval(handle);
                    this.current = this.target;
                }
            }, 1);
        },
    };
}
